<script setup>
import { useRouter } from 'vue-router'
import { onMounted } from 'vue'

const router = useRouter()

onMounted(() => {
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  const role = user?.roles?.[0]

  if (role === 'admin' || role === 'SuperAdmin') {
    router.replace({ name: 'LeaveManagement' })
  } else if (role === 'manager') {
    router.replace({ name: 'LeaveReview' })
  } else {
    router.replace({ name: 'LeaveRequest' })
  }
})
</script>

<template>
  <div class="text-center py-5">
    <h6>Redirecting...</h6>
  </div>
</template>
